// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line-binding-card[data-v-486317df]{word-break:break-word}.line-binding-summary[data-v-486317df]{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px}.line-binding-summary-item[data-v-486317df]{padding:12px;border:1px solid #dee2e6;border-radius:.25rem;background:#fff}.line-binding-label[data-v-486317df]{margin-bottom:6px;color:#6c757d;font-size:.875rem}.line-binding-value[data-v-486317df]{color:#212529;font-size:1rem}", ""]);
// Exports
module.exports = exports;
